import React, { memo, useState, Fragment } from "react";
import { makeStyles } from "@mui/styles";
import getProvincias from "./getProvincias";
import filterItems from "~libs/filterItems";
import SearcherList, {
  SearcherListChangeEvent,
} from "../searcherList/SearcherList";
import ListView from "../listView/ListView";
import localRepository from "../../../localRepository";

const useStyles = makeStyles((theme) => ({
  searcher: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    paddingTop: 10,
    justifyContent: "space-around",
  },
  chip: {
    borderRadius: "6px",
    fontWeight: "bold",
    margin: 2,
  },
}));

interface VehiculoProvinciaSelectorProps {
  value: any;
  onChange?: (event: { target: { value: string } }) => void;
}

// Las provincias tienen `value` numérico y la lista lo declara como texto;
// solo lo usa como clave y lo devuelve al seleccionar.
type ListViewItems = { label: string; value: string | null }[];

const provincias = getProvincias();

const VehiculoProvinciaSelector: React.FC<VehiculoProvinciaSelectorProps> =
  memo(({ onChange }) => {
    const [filter, setFilter] = useState<string>("");

    const mostUsedProv = localRepository.mostUsedProv
      .get()
      .sort((x, y) => y.count - x.count)
      .slice(0, 3);

    const handleItem = (item: { label: string; value: string | null }) => {
      setFilter("");
      if (onChange) onChange({ target: { value: item.value || "" } });
      localRepository.mostUsedProv.set(item);
    };

    const handleFilterChange = (event: SearcherListChangeEvent) => {
      setFilter(event.target.value);
    };

    const classes = useStyles();

    return (
      <Fragment>
        <div className={classes.searcher}>
          <SearcherList
            onClear={() => setFilter("")}
            filter={filter}
            onChange={handleFilterChange}
            placeholder={"Buscar provincia"}
            borderBottomRounded={false}
          />
          <ListView
            onItemSelected={handleItem}
            list={
              (filter === ""
                ? provincias
                : filterItems(provincias, filter)) as unknown as ListViewItems
            }
            mostUsedList={
              (filter === "" ? mostUsedProv : []) as unknown as ListViewItems
            }
          />
        </div>
      </Fragment>
    );
  });

export default VehiculoProvinciaSelector;
